// extracted by mini-css-extract-plugin
export default {"TransactionPin":"TransactionPin_TransactionPin__izV+D","Text":"TransactionPin_Text__Fnq3U","Error":"TransactionPin_Error__9kQhp"};